import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text, type TextProps } from "@similarweb/ui-components/foundations";

export const StyledCrmEnrichmentJobReviewSetting = styled(Stack).attrs({
    "data-automation": "setting-block",
})`
    gap: 8px;
    width: 100%;
    margin-bottom: 8px;
`;

export const StyledCrmEnrichmentJobReviewSettingsBlock = styled.div`
    display: flex;
    gap: 16px;
`;

export const StyledCaption = styled(Text).attrs<Partial<TextProps>>({
    fontVariant: "tab",
    color: colorsPalettes.carbon[300],
    "data-automation": "setting-value-title",
})`
    font-weight: 400;
`;

export const StyledValueText = styled(Text).attrs<Partial<TextProps>>({
    fontVariant: "tab",
    color: colorsPalettes.carbon[500],
    "data-automation": "setting-value-text",
})`
    font-weight: 400;
`;
